import { useHistory, useLocation } from "react-router-dom";

import ImgWrapper from "./ImgWrapper";
import Notifications from "views/notifications/Notifications";
import { useContext, useEffect } from "react";
import NaraIcon from "assets/icons/nara-icon.svg";
import Spacer from "./Spacer";
import UserOptions from "views/userAccount/UserOptions";
import { connect } from "react-redux";
import menuIcon from "assets/icons/sidebar_menu.svg";
import chatIcon from "assets/icons/supportIcon.svg";
import videoIcon from "assets/icons/orangePlayIcon.svg";
import styled from "styled-components";
import { useState } from "react";
import useIntercom from "hooks/useIntercom";
import NewTag from "./sidebar/NewTag";
import { TutorialContext } from "contexts/TutorialContext";
import useDevice from "hooks/useDevice";
import GlobalSearch from "./GlobalSearch";
import AiCreditGlobal from "./AiCreditGlobal";
import useIsMobile from "hooks/useIsMobile";
import SearchIcons from "assets/icons/search.svg";
import AiCreditIncrement from "views/aiAssistant/AiCreditIncrement";

const Wrapper = styled.nav`
  position: fixed;
  width: calc(100% - 240px);
  right: 0;
  top: 0;
  z-index: ${({ isShowUserOptions }) => (isShowUserOptions ? "12" : "10")};

  .page-title-flex {
    display: flex;
    align-items: center;
    gap: 24px;
  }

  .nav_action_center {
    gap: 8px;
  }

  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 7.2rem;
    padding: 0 24px;
    border-bottom: 1px solid #e5e7eb;
    background-color: var(--white);
    z-index: 12;
  }

  .mobileNotification {
    display: none;
  }

  .readCover {
    position: relative;
    z-index: 100;
    background: white;
    top: 20rem;
    left: 59%;
  }

  .chatSupport {
    padding: 12px;
    transition: all 0.2s ease-out;
    gap: 4px;
  }

  .tutorial_btn {
    background-color: #fff0eb;
    border: solid #ffc1af;
    color: #ff6436;
    font-size: 14px;
    height: 36px;
    padding: 8px;
    gap: 4px;
    border-radius: 8px;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    left: 0;

    .page-title-flex {
      display: none;
    }
    .nav_action_center {
      gap: 4px;

      .btn_text {
        display: none;
      }
    }
    .container {
      position: fixed;
      top: 7.3rem;
      display: flex;
      width: 100%;
    }

    .mobileNotification {
      position: fixed;
      background: #021128;
      display: flex;
      align-items: center;
      padding: 12px 24px;
      height: 7.2rem;
      top: 0;
      width: 100%;
      font-size: 14px;
      line-height: 20px;
      z-index: 12;

      .appDownload {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        .logContainer {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 6px 8.143px 6px 9px;
          border-radius: 8px;
          border: 1px solid #e2e2ea;
        }
      }
    }

    .mobileFix {
      height: 15rem;
    }
  }
`;

const User = styled.div`
  width: max-content;
  position: relative;

  .userIcon,
  .downIcon {
    height: 1.6rem;
  }

  .menu {
    background-color: var(--white);
    width: 16rem;
    border-radius: 0.4rem;
    position: absolute;
    top: 2.4rem;
    right: 0;
    box-shadow: 0px 0px 10px var(--background);
    z-index: 10;
    opacity: 0;
    pointer-events: none;
    transition: all 0.2s ease-out;

    &.show {
      top: 4.8rem;
      opacity: 1;
      pointer-events: all;
    }

    .item {
      padding: 1.6rem;
      width: 100%;
      text-align: left;

      &:hover {
        background-color: var(--background);
      }
    }
  }
`;

const Avatar = styled(ImgWrapper)`
  .initials {
    color: #ffffff;
    line-height: 18px;
  }
`;

const Back = styled.button`
  height: 100%;
  padding: 1.2rem 0;

  .icon {
    height: 36px;
    padding: 6px;
    background-color: var(--off_white);
    border-radius: 50%;
  }

  .iconMobile {
    height: 36px;
    padding: 6px;
    background-color: var(--off_white);
    border-radius: 4px;
  }
`;

const OpenSidebar = styled(Back)`
  display: none;
  left: 24px;

  @media screen and (max-width: 768px) {
    display: block;
  }
`;

const Navbar = ({ user, pageTitle }) => {
  const router = useHistory();
  const { handleWatchVideo, video } = useContext(TutorialContext);
  const [showUserOptions, setShowUserOptions] = useState(false);
  const { pathname } = useLocation();
  const device = useDevice();
  const [isAppInstalled, setIsAppInstalled] = useState(false);
  const isMobile = useIsMobile(768);
  const [showSearch, setShowSearch] = useState(false);
  const [openBuyCreditModal, setOpenBuyCreditModal] = useState(false);
  const { openSupportChat } = useIntercom({ user, autoBoot: false });

  const checkAppInstalled = () => {
    const appUrlScheme = "postpaddy.app://";
    const timeout = 1000;

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = appUrlScheme;
    document.body.appendChild(iframe);

    const start = Date.now();

    setTimeout(() => {
      if (Date.now() - start < timeout) {
        setIsAppInstalled(true);
      }
      document.body.removeChild(iframe);
    }, timeout);
  };

  useEffect(() => {
    checkAppInstalled();
  }, []);

  return (
    <>
      <Wrapper isShowUserOptions={showUserOptions}>
        <div className="mobileNotification colorWhite">
          {/* {device === "ios" ? ( */}
          <>Sign in on desktop to have an optimal PostPaddy experience.</>
          {/* ) : (
          <div className="appDownload">
            <div className="flexRow alignCenter">
              <div className="bgWhite logContainer">
                <Logo />
              </div>
              <Spacer x={0.5} />
              <div>
                <p className="semiBold">Postpaddy</p>
                <p>Open in PostPaddy App</p>
              </div>
            </div>

            <Button
              text={isAppInstalled ? "Open" : "Get app"}
              onClick={() => {
                window.open(
                  "https://play.google.com/store/search?q=postpaddy&c=apps&hl=en",
                  "_blank",
                  "noopener"
                );
              }}
            />
          </div>
        )} */}
        </div>
        <div className="container">
          <div className="flexRow justifyEnd alignCenter">
            {pathname.split("/").length > 3 &&
              !pathname.includes("analytics") && (
                <div className="flexRow lg">
                  <Back onClick={() => router.goBack()}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 icon"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="var(--grey_7)"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 19l-7-7 7-7"
                      />
                    </svg>
                  </Back>
                  <Spacer x={2.4} />
                </div>
              )}

            <div className="page-title-flex">
              {pageTitle === "Nara social assistant" && (
                <img src={NaraIcon} alt="nara social assistant" width="36px" />
              )}
              <h5
                className="lg pageTitle"
                title={pageTitle}
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "200px",
                }}
              >
                {pageTitle}
              </h5>
              {pageTitle === "Nara social assistant" && (
                <NewTag
                  text="Beta"
                  background="var(--secondary)"
                  color="#fff"
                />
              )}
            </div>
            <OpenSidebar
              className="openSidebar mb"
              onClick={() => {
                document.querySelector(".sidebar").classList.add("open");
                document
                  .querySelector(".sidebar-overlay")
                  .classList.add("open");
                document.body.classList.add("no-scroll");
              }}
            >
              <img
                src={menuIcon}
                alt="menu"
                className="iconMobile"
                title="Open sidebar"
              />
            </OpenSidebar>
          </div>
          {!isMobile && <GlobalSearch />}
          <div className="flexRow justifyEnd alignCenter nav_action_center">
            <AiCreditGlobal setOpenBuyCreditModal={setOpenBuyCreditModal} />
            {/* {video && (
              <button
                title="Watch tutorial video for this page"
                type="button"
                className="tutorial_btn flexRow alignCenter justifyCenter"
                onClick={handleWatchVideo}
              >
                <img src={videoIcon} alt="video tutorial" width="20px" />{" "}
                <span className="btn_text">View tutorial</span>
              </button>
            )} */}

            {isMobile && <GlobalSearch />}

            <button
              type="button"
              className="flexRow alignCenter chatSupport support-tour"
              title="Chat support"
            >
              <img src={chatIcon} alt="chat support" width="20px" />
            </button>

            <div className="notification-tour">
              <Notifications />
            </div>

            <User>
              <Avatar
                as="button"
                bg="var(--primary)"
                size={4}
                onClick={() => setShowUserOptions(true)}
                id="avi-target"
              >
                {user?.image ? (
                  <img
                    src={`${user.image}`}
                    alt="avatar"
                    className="setting-tour"
                  />
                ) : (
                  <h5 className="initials textCenter textUppercase setting-tour">{`${user?.full_name
                    ?.split(" ")[0]
                    .charAt(0)}${user?.full_name
                    ?.split(" ")[1]
                    .charAt(0)}`}</h5>
                )}
              </Avatar>
              {showUserOptions && (
                <UserOptions setShowUserOptions={setShowUserOptions} />
              )}
            </User>
          </div>
        </div>
        <div className="mobileFix"></div>
      </Wrapper>

      {openBuyCreditModal && (
        <AiCreditIncrement
          open={openBuyCreditModal}
          close={() => setOpenBuyCreditModal(false)}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    pageTitle: state.page_title,
  };
};

export default connect(mapStateToProps)(Navbar);
